import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default class LineChartTemplate2 extends React.Component {
    render() {
        const {
            graphData,
            colors,
            xLabel,
            yLabel,
            layoutItem
        } = this.props;

        const reportConfig = layoutItem && layoutItem.itemProperties && layoutItem.itemProperties.reportConfig;
        const { externalUrl, targetProperty } = reportConfig;

        const options = {
            responsive: true,
            maintainAspectRatio: false,

            onClick: (event, elements) => {

                if (!elements.length) return;

                if (externalUrl && targetProperty) {
                    const pointIndex = elements[0].index;
                    const clickedStockData = graphData[pointIndex];
                 
                    let str = targetProperty.replace('{{', '').replace('}}', '');
                    const prefix = '__ADDITIONAL_MODEL_DATA.';
                    if (str.startsWith(prefix)) {
                        str = str.replace(/^__ADDITIONAL_MODEL_DATA\.[^.]+\./, '');
                    }
                    const baseUrl = window.location.origin;
                    if (clickedStockData.xProperties) {
                        const redirectUrl = `${baseUrl}/app/${externalUrl}?ct=${str}:${clickedStockData.xProperties}`;
                        window.location.href = redirectUrl;
                    }
                }
            },


            animation: {
                duration: 1200,
                easing: 'easeOutQuart',
            },
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'circle',
                        padding: 16,
                        font: { size: 13, weight: 'bold' },
                    },
                },
                tooltip: {
                    enabled: true,
                    backgroundColor: '#1f2937',
                    titleColor: '#ffffff',
                    bodyColor: '#ffffff',
                    cornerRadius: 12,
                    padding: 14,
                    displayColors: true,
                    titleFont: { weight: 'bold' },
                },
                title: {
                    display: true,
                    text: yLabel,
                    font: { size: 18, weight: 'bold' },
                    padding: { bottom: 20 },
                },
            },
            hover: {
                mode: 'nearest',
                intersect: true,
            },
            scales: {
                x: {
                    grid: {
                        display: true,
                        drawBorder: false,
                        color: 'rgba(0,0,0,0.05)',
                        borderDash: [4, 4],
                    },
                    ticks: { font: { size: 12 } },
                    title: {
                        display: true,
                        text: xLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
                y: {
                    grid: {
                        borderDash: [6, 6],
                        color: 'rgba(0,0,0,0.06)',
                    },
                    ticks: { font: { size: 12 } },
                    title: {
                        display: true,
                        text: yLabel,
                        font: { size: 14, weight: 'bold' },
                    },
                },
            },
        };

        let labels = [];
        let yAxisData = [];

        if (graphData && graphData.length) {
            graphData.forEach(item => {
                labels.push(item.xProperties);
                yAxisData.push(item.yProperties);
            });
        }

        const chartData = {
            labels,
            datasets: [
                {
                    label: yLabel,
                    data: yAxisData,
                    tension: 0.4,
                    borderWidth: 3,
                    pointRadius: 6,
                    pointHoverRadius: 10,
                    pointHoverBackgroundColor: '#ffffff',
                    pointHoverBorderColor: colors,
                    pointHoverBorderWidth: 3,
                    borderColor: colors,
                    fill: false,
                },
            ],
        };

        return (
            <div
                style={{
                    height: '420px',
                    width: '100%',
                    maxWidth: '100%',
                    margin: 'auto',
                    padding: '20px',
                    background: '#ffffff',
                    borderRadius: '24px',
                    transition: 'all 0.3s ease',
                }}
            >
                <Line options={options} data={chartData} />
            </div>
        );
    }
}
